export default __webpack_public_path__ + "assets/img/job-card-icon02.png";